import { runtimeEnv } from '../runtimeEnv';

export class TermsAcceptError extends Error {
  constructor(public readonly status: number, url: string) {
    super(`${url} failed: ${status}`);
    this.name = 'TermsAcceptError';
  }
}

// Records the org's one-time terms acceptance (EIT-140). Nothing is sent in the body — the server
// stamps the current version and the caller's id. A 2xx means accepted; the caller need not refetch.
export async function acceptTerms(token: string, orgId: string, signal?: AbortSignal): Promise<void> {
  const url = `${runtimeEnv.entitlementsApiUrl}/organisations/${encodeURIComponent(orgId)}/terms-acceptance`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    signal,
  });
  if (!res.ok) throw new TermsAcceptError(res.status, url);
}
